<div
  [ngClass]="AppSettings.IsRunningInSingularity ? 'm-top-45' : 'm-top-55'"
></div>
<div
  class="kmt-toolbar with-bottom-border centered-toolbar custom-elevation-6 with-bottom-margin text-white primary-col"
  [ngClass]="
    AppSettings.IsRunningInSingularity ? 'main-header-sso' : 'main-header'
  "
>
  <div class="left-container" *ngIf="!AppSettings.IsRunningInSingularity">
    <div
      class="toolbar-items"
      fxLayout="row"
      fxLayoutGap="8px"
      fxLayoutAlign="start center"
    >
      <img class="toplogo" src="/assets/images/UnifocusLogo.png" />
      <div
        class="companyname_header"
        *ngIf="AppSettings.ShowICPNumber == 'true'"
      >
        <div class="icp-info text-white">京 ICP 备 18018594 号</div>
      </div>
      <!-- <div fxLayout="column">
        <div class="company-name">
          <span class="comp_first">KNOW</span
          ><span class="comp_second">MAINTENANCE</span>
        </div>
        <div class="tagline" fxLayout="row" fxLayoutGap="4px">
          <span class="icp-number" *ngIf="AppSettings.ShowICPNumber == 'true'">
            {{ 'LBL.ICPNUMBER' | translate }}
          </span>
        </div>
      </div> -->
    </div>
  </div>
  <div
    class="center-container mat-headline no-margin"
    [ngClass]="AppSettings.IsRunningInSingularity ? 'title-sso' : ''"
  >
    {{ title | translate }}
  </div>
  <div class="right-container">
    <div class="toolbar-items" fxLayout="row" fxLayoutGap="16px" *ngIf="user">
      <!-- user -->
      <div
        fxLayout="row"
        fxLayoutGap="8px"
        fxLayoutAlign="start center"
        *ngIf="!AppSettings.IsRunningInSingularity"
      >
        <div class="icon-avatar">
          <img *ngIf="user.HasImage" [src]="getStaffImage(user)" />
          <mat-icon
            *ngIf="!user.HasImage"
            [ngClass]="AppSettings.IsRunningInSingularity ? '' : 'text-white'"
            >account_circle</mat-icon
          >
        </div>
        <div fxLayout="column">
          <span>{{ user.FName }} {{ user.LName }}</span>
          <span class="mat-caption"
            >{{ user.Designation }} · {{ user.Department }}</span
          >
        </div>
      </div>


         <div class="property-date-time" *ngIf="PropertyDateTime && AppSettings.IsRunningInSingularity">
          {{PropertyDateTime}}
        </div>

      <!-- Language -->
      <ng-container
        *ngIf="AppFeatures.SetLanguage && supportedLanguages.length"
      >
        <button
          type="button"
          mat-icon-button
          [matTooltip]="cacheService.ActiveLanguageCode"
          [matMenuTriggerFor]="languageMenu"
        >
          <mat-icon class="mat-icon-medium">language</mat-icon>
          <mat-menu #languageMenu="matMenu">
            <button
              type="button"
              mat-menu-item
              *ngFor="let lang of supportedLanguages"
              (click)="didSelectUserLanguage(lang)"
            >
              {{ lang.Language }}
            </button>
          </mat-menu>
        </button>
      </ng-container>

      <button
        *ngIf="!AppSettings.IsRunningInSingularity"
        mat-icon-button
        [matMenuTriggerFor]="infomenu"
        style="margin: 0"
        [matTooltip]="'TITLE.TITLE_USR_INFO' | translate"
        class="help-btn"
      >
        <mat-icon
          [ngClass]="AppSettings.IsRunningInSingularity ? '' : 'text-white'"
          >info</mat-icon
        >
      </button>

      <mat-menu #infomenu="matMenu">
        <button mat-menu-item (click)="openDoc(1)">
          <span>{{ 'BTN.BTN_UNIFOCUS_SUPPORT' | translate }}</span>
        </button>
        <button mat-menu-item (click)="openDoc(2)">
          <span>{{ 'BTN.BTN_ONLINE_HELP' | translate }}</span>
        </button>
        <button mat-menu-item (click)="openDoc(3)">
          <span>{{ 'BTN.BTN_RELEASE_NOTE' | translate }}</span>
        </button>
        <button mat-menu-item (click)="openIdeas()">
          <span>{{ 'BTN.BTN_IDEAS_PORTAL' | translate }}</span>
        </button>
      </mat-menu>

      <!-- socket-->
      <div
        class="icon-container with-left-margin with-right-margin"
        fxLayout="column"
        fxLayoutAlign="center center"
        [class.status-success]="realtimeConnection"
        [class.status-fail]="!realtimeConnection"
      >
        <span
          class="header-font-icon"
          [class.ksv-icon-connection-on]="realtimeConnection"
          [class.ksv-icon-connection-off]="!realtimeConnection"
          [matTooltip]="
            (realtimeConnection
              ? 'NAV.NAV_CONNECTION_ICON_SUCCESS'
              : 'NAV.NAV_CONNECTION_ICON_ERROR'
            ) | translate
          "
        ></span>
      </div>
      <!-- notification -->
      <button
        mat-icon-button
        type="button"
        (click)="
          navHeader.notificationPanelOpened = true; navHeader.hasUnread = false
        "
      >
        <ng-container *ngIf="navHeader.hasUnread">
          <mat-icon class="text-white">notification_important</mat-icon>
        </ng-container>
        <ng-container *ngIf="!navHeader.hasUnread">
          <mat-icon
            [ngClass]="AppSettings.IsRunningInSingularity ? '' : 'text-white'"
            >notifications</mat-icon
          >
        </ng-container>
      </button>
    </div>
  </div>
</div>
